import { useMutation } from "@tanstack/react-query";

import { getAllMarkupsIsProposedAsTypical } from "@synthesis/shared-services/reporting/reportGenerationMarkupController/client";
import {
  exportAllModelsReport,
  exportSoftwareModelsBySoftwareName,
  getExcelReportModelsSoftwareMetadata,
} from "@synthesis/shared-services/reporting/reportGenerationModelsController/client";
import { logger } from "@synthesis/shared-utils";

import { downloadFile } from "../../shared/utils/download-file";
import { reportingQueryKeys } from "./reporting.constants";

const reportBlobConfig = { responseType: "blob" as const };

const asReportBlob = (data: unknown): Blob => {
  if (data instanceof Blob) return data;
  throw new Error("Unexpected report response format");
};

export const useDownloadOfferForTypicalMarkups = () =>
  useMutation({
    mutationKey: [...reportingQueryKeys.all, "markup-typical"],
    mutationFn: async () => asReportBlob((await getAllMarkupsIsProposedAsTypical(reportBlobConfig)).data),
    onSuccess: (data) => downloadFile(data, "Предложение по типовым замечаниям"),
    onError: (e) => logger.error(e),
  });

export const useDownloadModelSoftwareReport = () =>
  useMutation({
    mutationKey: [...reportingQueryKeys.all, "excel-model-software"],
    mutationFn: async () => asReportBlob((await getExcelReportModelsSoftwareMetadata(reportBlobConfig)).data),
    onSuccess: (data) => downloadFile(data, "Статистика по использованию ПО"),
    onError: (e) => logger.error(e),
  });

export const useDownloadModelSoftwareDetailsReport = (softwareName?: string) =>
  useMutation({
    mutationKey: [...reportingQueryKeys.modelSoftwareDetails(softwareName), "excel"],
    mutationFn: async () => {
      if (!softwareName) throw new Error("softwareName is required");
      return asReportBlob((await exportSoftwareModelsBySoftwareName({ ...reportBlobConfig, path: { softwareName } })).data);
    },
    onSuccess: (data) => downloadFile(data, "Детальный отчёт по файлам"),
    onError: (e) => logger.error(e),
  });

export const useDownloadExcelFileReport = () =>
  useMutation({
    mutationKey: [...reportingQueryKeys.all, "excel-file-report"],
    mutationFn: async () => asReportBlob((await exportAllModelsReport(reportBlobConfig)).data),
    onSuccess: (data) => downloadFile(data, "Файловый отчёт"),
    onError: (e) => logger.error(e),
  });
